(function ($) {
  $(document).ready(function () {

    var hash = window.location.hash;


    if (hash) {
      hash = hash.replace('#', '')
      // Scroll to the corresponding section
      var targetSection = $('section[data-menu="' + hash + '"]');
      if (targetSection.length) {
        $('html, body').animate({
          scrollTop: targetSection.offset().top
        }, 800);
      }
    }


    $('.project-related__slick').slick({
      slidesToShow: 1.6,
      infinite: false,
      prevArrow: $('.btn-prev'),
      nextArrow: $('.btn-next'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,

          }
        }
      ]
    })
    $('#audio-player-container').slick({
      slidesToShow: 1,
      infinite: false,
      arrows: false,
      infinite: false,
      swipe: false,
      swipeToSlide: false
    })
    $('.previous-icon').on('click', function () {
      var dataId = $('.slick-current').attr("data-slick-index");
      $('#audio-player-container').slick('slickGoTo', dataId - 1)
    })
    $('.next-icon').on('click', function () {
      var dataId = $('.slick-current').attr("data-slick-index");
      $('#audio-player-container').slick('slickGoTo', dataId + 1)
    })

    $('.slick-contact').slick({
      slidesToShow: 1,
      infinite: false,
      arrows: false,
      infinite: false,
      fade: true,
      cssEase: 'linear'
      // swipe: false,
      // swipeToSlide: false
    })

    $('.slick-next').on('click', function () {
      $('.slick-contact').slick('slickNext');
    });


    if (getParameterByName('skip') == "yes") {
      $('.slick-contact').slick('slickGoTo', 1);
    }



    $('.slick-end').on('click', function (e) {
      e.preventDefault()
      var seize_rest = seize_data.site_url + '/wp-json/site/v1';
      var formData = new FormData(document.getElementById("send-contact"));
      $.ajax({
        url: seize_rest + '/sendContact',
        dataType: "json",
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false, //"application/json",
        cache: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          $('.template-contact_hero').html(response);
        }
      });
    })

    $('.input-inner input').on('input', function () {
      const value = $(this).val();
      const type = $(this).attr('type'); // Get the input type
      const required = $(this).attr('required');
      let isValid = false;

      if (required) {


        if (type === "email") {
          // Basic email validation
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          isValid = emailRegex.test(value);
        } else if (type === "tel") {
          // Basic phone validation (allowing digits, spaces, dashes, parentheses)
          const phoneRegex = /^[+]?[\d\s-()]{7,}$/;
          isValid = phoneRegex.test(value);
        } else {
          // Default validation: check if not empty
          isValid = value.trim() !== "";
        }

        if (isValid) {
          $(this).siblings('.slick-button').addClass('active');
        } else {
          $(this).siblings('.slick-button').removeClass('active');
        }
      }
    });


    AOS.init({
      duration: 1000, // Animation duration (in milliseconds)
      once: true, // Animation occurs only once
    });






    switchLogo();
    $(window).scroll(function () {
      switchLogo()
      getSectionUuid()
    });

    $('#menu-menu-principal a').on('click', function () {
      console.log($(this))
      if ($(this).prop('title')) {
        $('html, body').animate({
          scrollTop: $('section[data-menu="' + $(this).prop('title') + '"]').offset().top
        }, 800); // 800 milliseconds for the scroll animation
      }
    })

    const $images = $(".hero-team__image");
    let currentIndex = 0;

    function showNextImage() {
      if (currentIndex == 0) {
        $images.css('opacity', 0)
      }
      // Show the current image with a fade-in effect
      $images.eq(currentIndex).css('opacity', 1);

      // Move to the next index, looping back if at the end
      currentIndex = (currentIndex + 1) % $images.length;
    }

    if ($('.hero-team__image')) {
      // Start the animation loop
      setInterval(showNextImage, 500);
      // Optionally show the first image immediately
      showNextImage();
    }

    $('.habitat-slick').slick({
      slidesToShow: 4,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      cssEase: 'linear',
    })


    if ($('.services-section').length > 0) {


      const scrollContent = document.querySelector(".scroll-content");
      const panels = document.querySelectorAll(".panel");
      let totalPanelsWidth = 0;

      panels.forEach(panel => {
        totalPanelsWidth += panel.offsetWidth; // Add the width of each panel
      });
      gsap.set(scrollContent, { width: totalPanelsWidth });

      // Create the horizontal scroll animation
      gsap.to(scrollContent, {
        x: -(totalPanelsWidth - window.innerWidth), // Negative scroll distance
        ease: "none",
        scrollTrigger: {
          trigger: ".services-section",
          start: "top top",
          end: () => `+=${totalPanelsWidth}`, // Total width of the panels
          scrub: true,
          pin: true,
        },
      });
    }

    $('.contact-file').on('change', function (e) {
      var label = $('label[for="file-input"]');
      var labelVal = label.html();

      var fileName = '';
      if (this.files && this.files.length > 1) {
        fileName = (input.data('multiple-caption') || '').replace('{count}', this.files.length);
        console.log(fileName);
      } else {
        fileName = e.target.value.split('\\').pop();
        console.log(fileName)
      }

      if (fileName) {
        label.html(fileName);
      }
      else {
        label.html(labelVal);
      }
    });

    $('.header-menu__hamburger').on('click', function () {
      $('.header-menu__container').toggleClass('active')
      $(this).toggleClass('active')
    })
    $('.header-menu__mobile a').on('click', function () {
      $('.header-menu__hamburger').toggleClass('active')
      $('.header-menu__mobile').toggleClass('active')
      if ($(this).prop('title')) {
        $('html, body').animate({
          scrollTop: $('section[data-menu="' + $(this).prop('title') + '"]').offset().top - 50
        }, 800); // 800 milliseconds for the scroll animation
      }
    })
    audioPlayer();



    const sections = $('.project');

    if (sections.length > 0) {
      const viewportHeight = $(window).height();
      const footerHeight = $("footer").outerHeight(true);
      let isScrolling = false;

      const scrollToSection = (index) => {
        if (isScrolling) return;
        isScrolling = true;

        let scrollTarget = index * viewportHeight;

        // If scrolling past the last section, show the footer
        if (index === sections.length) {
          scrollTarget = $(document).height() - viewportHeight; // Scroll to bottom
        }

        $("html, body").animate(
          { scrollTop: scrollTarget },
          800,
          function () {
            isScrolling = false;
          }
        );
      };

      $(window).on("wheel", function (event) {
        const delta = event.originalEvent.deltaY;
        const currentScroll = $(window).scrollTop();
        const currentIndex = Math.round(currentScroll / viewportHeight);
        let nextIndex = delta > 0 ? currentIndex + 1 : currentIndex - 1;

        // Allow one more step beyond the last section to show the footer
        nextIndex = Math.max(0, Math.min(nextIndex, sections.length));

        scrollToSection(nextIndex);
      });

      $(window).on("keydown", function (event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          event.preventDefault();
          const currentScroll = $(window).scrollTop();
          const currentIndex = Math.round(currentScroll / viewportHeight);
          let nextIndex = event.key === "ArrowDown" ? currentIndex + 1 : currentIndex - 1;

          // Allow one more step beyond the last section to show the footer
          nextIndex = Math.max(0, Math.min(nextIndex, sections.length));

          scrollToSection(nextIndex);
        }
      });
    }



  });
})(jQuery);


function switchLogo() {
  var scrollTop = 200;
  var scrollLeft = 20;

  if (document.elementFromPoint(scrollLeft, scrollTop).classList.contains('logoAlt')) {
    $('header').addClass('alternate')

  } else {
    if ($('header').hasClass('alternate')) {
      $('header').removeClass('alternate')
    }

  }
}

function getSectionUuid() {
  var scrollTop = 200;
  var scrollLeft = 20;

  let sectionUuid = document.elementFromPoint(scrollLeft, scrollTop).dataset.menu
  $('#menu-menu-principal a').removeClass('active')
  $('#menu-menu-principal a[title="' + sectionUuid + '"]').addClass('active')
}

function audioPlayer() {
  console.log('coucou')
  const audio = $('.audio-each');

  const calculateTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = Math.floor(secs % 60);
    const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${returnedSeconds}`;
  }

  audio.each(function () {
    const audioSingle = $(this).find('audio')
    const seekSlider = $(this).closest('.seek-slider');
    const seekAmount = $(this).closest('.amount');
    let playState
    audioSingle[0].addEventListener('loadedmetadata', () => {
      console.log(calculateTime(audioSingle[0].duration));

      seekSlider.attr('max', Math.floor(audioSingle[0].duration));
      console.log(seekSlider.max = Math.floor(audioSingle[0].duration))
      const playIcon = $(this).find('.play-icon')

      playIcon.on('click', function () {
        if (audioSingle[0].paused) {
          audio.each(function () {
            $(this).find('audio')[0].pause();
            $(this).find('.play-icon').removeClass('active')
          })
          audioSingle[0].play();
          $(this).addClass('active')
          playState = 'play';
        } else {
          audioSingle[0].pause();
          playState = 'pause';
          $(this).removeClass('active')
        }
      });

      $('.audio-player-container').on('input', '.testrange', function () {
        // Your event handler code here
        console.log('allobis')
        console.log(seekAmount.value)
        audioSingle[0].currentTime = parseFloat(seekSlider.val());
      });

      audioSingle[0].addEventListener('timeupdate', () => {
        let playBack = audioSingle[0].currentTime
        console.log(playBack)
        seekSlider.value = playBack
      });
    })


  })


}

function getParameterByName(name) {
  let url = new URL(window.location.href);
  return url.searchParams.get(name);
}

